<template>
  <!-- ホーム画面 -->
  <div id="UrgentScheduleOnlyHome">
    <!-- 上部余白 -->
    <div style="height: 10px;" />

    <div style="margin-left: 50px; margin-right: 50px;">
      <div class="alert title is-6" v-if="isShowtAlert">
        <div>
          <p>アラート</p>
        </div>
      </div>
      <div class="notice title is-6">お知らせ</div>
      <div class="columns">
        <div class="column is-four-fifths">
          <b-field :type="{'is-danger':errors.has('notice')}" :message="errors.first('notice')">
            <b-input
              type="textarea"
              v-model="notice"
              class="box"
              style="text-align: left;"
              name="notice"
              data-vv-as="お知らせ"
              v-validate="'max:512'"
              maxlength="512"
              :readonly="true"
            ></b-input>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UrgentScheduleOnlyHome",
  methods: {
    getNotice: function() {
      var excuteApi = this.getNoticePOST;
      var successCallBack = this.getNoticeSuccess;
      var errorCallBack = this.getNoticeError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getNoticePOST: function(client) {
      return client.apis.apiCommon.getAnnouncementPOST({});
    },
    getNoticeSuccess: function(result) {
      this.notice = result.obj.information;
      if (!this.notice) {
        this.notice = "お知らせはありません。";
      }
    },
    getNoticeError: function(result) {
      console.log(result);
      this.notice = "お知らせを取得できませんでした。";
    }
  },
  data() {
    return {
      notice: "",
      isShowtAlert: false
    };
  },
  components: {},
  mounted: function() {
    this.getNotice();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/home/UrgentScheduleOnlyHome.vue